import { isDevMode } from "@angular/core";
import { LocaleConfig, LocalizationConfig } from "@localization";
import { getDefaultLang } from "../utils/i18n.utils";
import { AVAILABLE_LANGUAGES, BASE_URL_i18n, FALLBACK_LANGUAGE } from "../constants/i18n.constants";

const LOCALE_CONFIG: LocaleConfig = {
  langToLocaleMapping: {
    en: 'en-GB',
    es: 'es-ES',
  },
}

export const LOCALIZATION_CONFIG: LocalizationConfig = {
  baseUrl: BASE_URL_i18n,
  availableLangs: AVAILABLE_LANGUAGES,
  defaultLang: getDefaultLang(),
  reRenderOnLangChange: true,
  prodMode: !isDevMode(),
  fallbackLang: FALLBACK_LANGUAGE,
  failedRetries: 0,
  flatten: {
    aot: false,
  },
  localeConfig: LOCALE_CONFIG,
};
